export default "__VITE_ASSET__TBs_xHbX__"